import { Search } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";

interface SearchFieldProps {
  disabled?: boolean;
  value: string;
  onChange: any;
  fullWidth?: boolean;
}

export function SearchField({
  disabled = false,
  value,
  onChange,
  fullWidth = false,
}: SearchFieldProps) {
  return (
    <TextField
      disabled={disabled}
      fullWidth={fullWidth}
      size="small"
      placeholder="Search"
      value={value}
      onChange={onChange}
      inputProps={{ sx: { padding: "4px", minWidth: "222px" } }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 0 }}>
            <Search />
          </InputAdornment>
        ),
        sx: { pl: "5px" },
      }}
    />
  );
}